const GTM_ID_REGEX = /GTM-[A-Z0-9]+/i
const GTM_LOADER_REGEX = /googletagmanager\.com\/gtm\.js/i

function scriptText(script) {
	return [script?.src, script?.innerHTML].filter(Boolean).join(' ')
}

export function isGtmScript(script) {
	if (!script) return false

	const text = scriptText(script)

	if (script.tag === 'noscript') {
		return GTM_ID_REGEX.test(text) && /googletagmanager\.com/i.test(text)
	}

	if (GTM_LOADER_REGEX.test(script.src || '')) return true

	return GTM_ID_REGEX.test(text) && /googletagmanager/i.test(text)
}

export function extractGtmContainerId(script) {
	const match = scriptText(script).match(GTM_ID_REGEX)
	return match ? match[0].toUpperCase() : null
}

export function partitionGtmScripts(scripts) {
	const filtered = []
	let gtmContainerId = null

	for (const script of scripts) {
		if (isGtmScript(script)) {
			gtmContainerId = gtmContainerId || extractGtmContainerId(script)
			continue
		}
		filtered.push(script)
	}

	return { filtered, gtmContainerId }
}

export function partitionSeomaticScripts(headScripts, bodyScripts) {
	const head = partitionGtmScripts(headScripts)
	const body = partitionGtmScripts(bodyScripts)

	return {
		headScripts: head.filtered,
		bodyScripts: body.filtered,
		gtmContainerId: head.gtmContainerId || body.gtmContainerId || null,
	}
}
